import {Box, Typography, styled} from '@mui/material';
import {MdFiberManualRecord} from 'react-icons/md';

export interface RecordingOverlayProps {
  lapsedDuration: string;
  totalDuration: string;
  isRecording?: boolean;
}

export const RecordingOverlay = (props: RecordingOverlayProps) => {
  return (
    <Box
      sx={{
        zIndex: 2,
        position: 'absolute',
        top: 0,
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        p: 2,
        alignItems: 'center',
      }}
    >
      <Box sx={{background: '#fff', px: 1, borderRadius: 4}}>
        <Typography variant="subtitle3">
          {props.lapsedDuration}/{props.totalDuration}
        </Typography>
      </Box>
      {props.isRecording && (
        <Box sx={{display: 'flex', alignItems: 'center', gap: 0.5}}>
          <Typography variant="subtitle3" lineHeight={0} color="error">
            <MdFiberManualRecord />
          </Typography>
          <Typography variant="subtitle3">REC</Typography>
        </Box>
      )}
    </Box>
  );
};

RecordingOverlay.DefaultProps = {
  lapsedDuration: '00:00',
  totalDuration: '01:00',
  isRecording: true,
};

export const IconContainer = styled(Box)<any>(({}) => ({
  width: 60,
  height: 60,
  borderRadius: '100%',
  backgroundColor: '#fff',
  position: 'absolute',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  left: 0,
  right: 0,
  top: 0,
  zIndex: 10,
  bottom: 0,
  margin: 'auto',
  fontSize: '22px',
  cursor: 'pointer',
  // opacity: iconOnHover ? 0 : 1,
  // ':hover': {
  //   opacity: 1,
  // },
}));
